import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IoService } from '../../../services/io/io.service';

@Component({
  selector: 'app-text-suggest',
  templateUrl: './text-suggest.component.html',
  styleUrls: ['./text-suggest.component.scss']
})
export class TextSuggestComponent implements OnInit {

  @Input() path: string = '';
  @Input() value: string = '';
  @Input() module: string = '';
  @Input() params: any = {};
  @Input() excludeValues: string[] = [];

  @Output() valueChange = new EventEmitter<string>();
  @Output() suggestionSelected = new EventEmitter<string>();

  selectedIndex = null;
  suggestions: any = null;
  debounceTime = 300;
  debounceTimeout: any;

  constructor(
    private ioService: IoService
  ) { }

  ngOnInit(): void {
  }

  inputChanged = async () => {
    // Propagate the typed value immediately — a save must never depend on the
    // debounced (and failable) suggestions fetch having completed.
    this.valueChange.emit(this.value);

    // Debounce the suggestions fetch
    clearTimeout(this.debounceTimeout);
    this.debounceTimeout = setTimeout(async () => {
      this.selectedIndex = null;

      try {
        let suggestionsResponse: any = await this.ioService.post('/' + this.module + '/getFieldValueSuggestions', {
          ...this.params,
          path: this.path,
          value: this.value
        });

        this.suggestions = this.excludeValues.length
          ? suggestionsResponse.suggestions.filter(s => !this.excludeValues.includes(s.value))
          : suggestionsResponse.suggestions;
      } catch (e) {
        this.suggestions = null;
      }
    }, this.debounceTime);
  }

  selectSuggestion = (suggestion: string) => {
    this.value = suggestion;
    this.suggestions = null;

    this.valueChange.emit(this.value);
    this.suggestionSelected.emit(this.value);
  }

  disregardSuggestions = () => {
    setTimeout(() => {
      this.suggestions = null;
    }, 200);
  }

  onKeyDown = (event: KeyboardEvent) => {
    if (!this.suggestions || this.suggestions.length === 0) return;

    switch (event.key) {
      case 'ArrowDown':
        this.selectedIndex = (this.selectedIndex === null || this.selectedIndex === this.suggestions.length - 1) ? 0 : this.selectedIndex + 1;
        break;
      case 'ArrowUp':
        this.selectedIndex = (this.selectedIndex === null || this.selectedIndex === 0) ? this.suggestions.length - 1 : this.selectedIndex - 1;
        break;
      case 'Enter':
        if (this.selectedIndex !== null) {
          this.selectSuggestion(this.suggestions[this.selectedIndex].value);
        }
        break;
      default:
        break;
    }
  }

}
